<template>
  <b-modal
    ref="modal-approve"
    id="modal-approve"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="px-3 py-5 text-center">
      <img src="@/assets/icon-delete.png" alt="" width="120" height="120">
      <h4 class="text-bold mt-4">Confirmation</h4>
      <p class="text-muted mb-5">
        Are you sure want to {{ text }} ?
      </p>
      <div class="d-flex justify-content-around align-items-center mt-5">
      <b-button class="btn-reset px-5" variant="outline-info" @click="submit" :disabled="isLoading">
        Yes
      </b-button>
      <b-button class="btn-custom px-5" variant="info" @click="cancel">
        No
      </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    text: {
      types: String,
      default: () => 'nice'
    },
    form: {
      types: Boolean,
      default: () => false
    }
  },

  data: () => ({
    isLoading: false
  }),

  methods: {
    submit() {
      this.isLoading = !this.isLoading
      this.$bvModal.hide('modal-approve')
      this.$emit('submit', this.form)
      this.isLoading = !this.isLoading
    },
    cancel() {
      this.$bvModal.hide('modal-approve')
    }
  }
}
</script>
